/**
 * @jest-environment jsdom
 */

 import React from 'react';
 import renderer from 'react-test-renderer';
 import Carousel from './';

 const images = [];
 const featured_image_id = null

 describe('<Carousel>', () => {

   it('should match snapshot', () => {
     const tree = renderer.create(
       <Carousel images={images} featured_image_id={featured_image_id} />
     ).toJSON();
     expect(tree).toMatchSnapshot();
   });

 });



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/Activities/Carousel/index.test.jsx